var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('div',{staticClass:"wrapper box-shadow"},[_c('b-row',{staticClass:"align-items-center img-panel"}),_c('b-row',[_c('b-col',[_c('p',[_vm._v(_vm._s(_vm.message))])])],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }